import React, { useContext } from "react";
import { ArrowRight } from "lucide-react";
import { LanguageContext } from "../context/LanguageContext";
import { Section, SectionHeader } from "./ui/Section";
import { Button } from "./ui/Button";

const DashboardShowcase = () => {
  const { dashboardShowCaseTitle, dashboardDescription, learnMore } = useContext(LanguageContext);

  return (
    <Section tone="light" id="dashboard">
      <div className="grid items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeader title={dashboardShowCaseTitle} lead={dashboardDescription} size="md" />
          <Button to="/login" variant="secondary" size="lg" className="mt-8">
            {learnMore}
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
        <div className="lg:col-span-7">
          <div className="overflow-hidden rounded-[2rem] border border-brand-line bg-white">
            <img
              src="/pc-mobile.webp"
              width="1920"
              height="1080"
              loading="lazy"
              alt="WashWorth owner dashboard on laptop and phone showing sales trends and peak hours"
              className="h-auto w-full"
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default DashboardShowcase;
